import { content } from './constants';

export const removePopup = (): void => {
    const popup = document.querySelector(`#${content.PRIVACY_POPUP.id}`);
    if (popup && popup.parentNode) {
        popup.parentNode.removeChild(popup);
    }
};

export const buildCloseButtonElement = (handleClick: () => void): HTMLElement => {
    const buttonElement = document.createElement('button');
    buttonElement.classList.add(content.PRIVACY_POPUP.CLOSE_BUTTON.class);
    buttonElement.setAttribute('type', 'button');
    buttonElement.setAttribute('aria-label', content.PRIVACY_POPUP.CLOSE_BUTTON.ariaLabel);
    buttonElement.addEventListener('click', handleClick);

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.classList.add(content.PRIVACY_POPUP.CLOSE_BUTTON.iconClass);
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute(
        'd',
        'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
    );
    path.setAttribute('fill', 'currentColor');

    svg.appendChild(path);
    buttonElement.appendChild(svg);

    return buttonElement;
};

export const buildHeaderElement = (handleCloseClick: () => void): HTMLElement => {
    const headerElement = document.createElement('div');
    headerElement.classList.add(content.PRIVACY_POPUP.HEADER.class);

    const titleElement = document.createElement('h2');
    titleElement.textContent = content.PRIVACY_POPUP.HEADER.title;

    const closeButton = buildCloseButtonElement(handleCloseClick);

    headerElement.appendChild(titleElement);
    headerElement.appendChild(closeButton);
    return headerElement;
};

export const buildMessageElement = (): HTMLElement => {
    const messageElement = document.createElement('div');
    messageElement.classList.add(content.PRIVACY_POPUP.MESSAGE.class);
    messageElement.innerHTML = content.PRIVACY_POPUP.MESSAGE.html;
    return messageElement;
};

export const buildPopupElement = (handleAcceptClick: () => void): HTMLElement => {
    const popupElement = document.createElement('div');
    popupElement.id = content.PRIVACY_POPUP.id;
    popupElement.classList.add(content.PRIVACY_POPUP.class);
    popupElement.setAttribute('role', 'dialog');
    popupElement.setAttribute('aria-label', 'Privacy Policy Notice');
    popupElement.setAttribute('aria-modal', 'false');

    const handleKeydown = (e: KeyboardEvent): void => {
        if (e.key === 'Escape') {
            handleAcceptClick();
        }
    };
    popupElement.addEventListener('keydown', handleKeydown);

    const containerElement = document.createElement('div');
    containerElement.classList.add(content.PRIVACY_POPUP.CONTAINER.class);

    const headerElement = buildHeaderElement(handleAcceptClick);

    const messageElement = buildMessageElement();

    containerElement.appendChild(headerElement);
    containerElement.appendChild(messageElement);
    popupElement.appendChild(containerElement);

    return popupElement;
};
